<mat-nav-list>
  @for (menuItem of menuItems(); track menuItem.id) {
    <div
      [matTooltip]="menuItem.label"
      [matTooltipDisabled]="false"
      matTooltipPosition="right"
      class="menu-item"
    [class]="{
      selected: menuItem.id === selectedMenuItemId(),
      selectable: isSelectable()
    }">
      <div class="color-bar"></div>
      @if (isFavoriteEnabled() && isWide()) {
        <div class="favorite-buttons">
          @if (isFavorite()[menuItem.id]) {
            <button type="button"
              mat-icon-button
              [matTooltip]="'Menu.RemoveFromFavorites' | translate"
              (click)="removeMenuItemFromFavorite(menuItem)">
              <mat-icon>favorite</mat-icon>
            </button>
          } @else {
            <button type="button"
              mat-icon-button
              [matTooltip]="'Menu.AddToFavorites' | translate"
              (click)="addMenuItemToFavorite(menuItem)">
              <mat-icon>favorite_border</mat-icon>
            </button>
          }
        </div>
      }
      <mat-list-item menuItem (click)="onMenuItemClick(menuItem)">
        <app-menu-item [widgetId]="menuItem.id"
          [uiScripts]="menuItem.uiScripts"
          [name]="menuItem.name"
          [shortLabel]="menuItem.shortLabel"
          [label]="menuItem.label"
          [isWide]="isWide()"
          [isRootLevel]="false"
          [icon]="menuItem.icon"
          [isSelected]="menuItem.id === selectedMenuItemId()"
           />
      </mat-list-item>
    </div>
  }
</mat-nav-list>
